// src/constants/kotakConstants.js
export const GET_ALL_KOTAK_RECORDS_REQUEST = 'GET_ALL_KOTAK_RECORDS_REQUEST';
export const GET_ALL_KOTAK_RECORDS_SUCCESS = 'GET_ALL_KOTAK_RECORDS_SUCCESS';
export const GET_ALL_KOTAK_RECORDS_FAIL = 'GET_ALL_KOTAK_RECORDS_FAIL';
export const GET_ALL_KOTAK_RECORDS_RESET = 'GET_ALL_KOTAK_RECORDS_RESET';

export const CREATE_KOTAK_RECORD_REQUEST = 'CREATE_KOTAK_RECORD_REQUEST';
export const CREATE_KOTAK_RECORD_SUCCESS = 'CREATE_KOTAK_RECORD_SUCCESS';
export const CREATE_KOTAK_RECORD_FAIL = 'CREATE_KOTAK_RECORD_FAIL';
export const CREATE_KOTAK_RECORD_RESET = 'CREATE_KOTAK_RECORD_RESET';

export const UPDATE_KOTAK_RECORD_REQUEST = 'UPDATE_KOTAK_RECORD_REQUEST';
export const UPDATE_KOTAK_RECORD_SUCCESS = 'UPDATE_KOTAK_RECORD_SUCCESS';
export const UPDATE_KOTAK_RECORD_FAIL = 'UPDATE_KOTAK_RECORD_FAIL';
export const UPDATE_KOTAK_RECORD_RESET = 'UPDATE_KOTAK_RECORD_RESET';

export const DELETE_KOTAK_RECORD_REQUEST = 'DELETE_KOTAK_RECORD_REQUEST';
export const DELETE_KOTAK_RECORD_SUCCESS = 'DELETE_KOTAK_RECORD_SUCCESS';
export const DELETE_KOTAK_RECORD_FAIL = 'DELETE_KOTAK_RECORD_FAIL';
export const DELETE_KOTAK_RECORD_RESET = 'DELETE_KOTAK_RECORD_RESET';

export const BULK_DELETE_KOTAK_RECORDS_REQUEST = 'BULK_DELETE_KOTAK_RECORDS_REQUEST';
export const BULK_DELETE_KOTAK_RECORDS_SUCCESS = 'BULK_DELETE_KOTAK_RECORDS_SUCCESS';
export const BULK_DELETE_KOTAK_RECORDS_FAIL = 'BULK_DELETE_KOTAK_RECORDS_FAIL';
export const BULK_DELETE_KOTAK_RECORDS_RESET = 'BULK_DELETE_KOTAK_RECORDS_RESET';

export const IMPORT_KOTAK_RECORDS_REQUEST = 'IMPORT_KOTAK_RECORDS_REQUEST';
export const IMPORT_KOTAK_RECORDS_SUCCESS = 'IMPORT_KOTAK_RECORDS_SUCCESS';
export const IMPORT_KOTAK_RECORDS_FAIL = 'IMPORT_KOTAK_RECORDS_FAIL';
export const IMPORT_KOTAK_RECORDS_RESET = 'IMPORT_KOTAK_RECORDS_RESET';

export const EXPORT_KOTAK_RECORDS_REQUEST = 'EXPORT_KOTAK_RECORDS_REQUEST';
export const EXPORT_KOTAK_RECORDS_SUCCESS = 'EXPORT_KOTAK_RECORDS_SUCCESS';
export const EXPORT_KOTAK_RECORDS_FAIL = 'EXPORT_KOTAK_RECORDS_FAIL';
export const EXPORT_KOTAK_RECORDS_RESET = 'EXPORT_KOTAK_RECORDS_RESET';

export const SYNC_KOTAK_TASK_STATUS_REQUEST = 'SYNC_KOTAK_TASK_STATUS_REQUEST';
export const SYNC_KOTAK_TASK_STATUS_SUCCESS = 'SYNC_KOTAK_TASK_STATUS_SUCCESS';
export const SYNC_KOTAK_TASK_STATUS_FAIL = 'SYNC_KOTAK_TASK_STATUS_FAIL';
export const SYNC_KOTAK_TASK_STATUS_RESET = 'SYNC_KOTAK_TASK_STATUS_RESET';
